/*
  Predictive Search Web Component
  Handles instant live search results as user types for desktop header & mobile offcanvas
*/

class PredictiveSearch extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    if (!this.form) return
    this.input = this.form.querySelector('input[type="search"]')
    if (!this.input) return

    this.clearBtn = this.form.querySelector('.search-clear-btn')
    this.results = this.querySelector('#predictive-search') || this.querySelector('.header-search-results-dropdown') || this.form.querySelector('#predictive-search')
    this.status = this.querySelector('#predictive-search-status')
    this.emptyContainer = this.querySelector('.search-empty')
    this.cartUpsells = this.querySelector('#card-upsells-collapse-wrapper')

    this.debounceTimer = null

    this.toggleClearBtn()

    this.input.addEventListener('input', (event) => {
      this.toggleClearBtn()
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.getSearchResults()
      }, 200)
    })

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.input.value = ''
        this.toggleClearBtn()
        this.closeResults()
        this.input.focus()
      })
    }

    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length) {
        this.getSearchResults()
      }
    })

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeResults()
      }
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeResults()
      }
    })

    document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
      this.input.focus()
    })
  }

  toggleClearBtn () {
    if (!this.clearBtn) return
    if (this.input.value.trim().length > 0) {
      this.clearBtn.style.display = 'flex'
    } else {
      this.clearBtn.style.display = 'none'
    }
  }

  async getSearchResults () {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.closeResults()
      return
    }

    this.setAttribute('loading', 'true')
    if (this.results) this.results.classList.add('is-loading')

    try {
      const resourcesType = this.dataset.resourcesType || 'query,product,collection'
      const routesUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.predictive_search_url) || '/search/suggest'
      const searchUrl = `${routesUrl}?q=${encodeURIComponent(searchTerm)}&resources[type]=${resourcesType}&resources[limit]=8&section_id=predictive-search`

      const response = await fetch(searchUrl)

      if (response.ok) {
        const data = await response.text()
        const parsedDoc = new DOMParser().parseFromString(data, 'text/html')
        const resultsElement = parsedDoc.querySelector('#shopify-section-predictive-search') || parsedDoc.querySelector('#predictive-search-results')

        if (resultsElement && this.results) {
          this.results.innerHTML = resultsElement.innerHTML
          this.results.style.display = 'block'
          this.results.classList.remove('is-loading')
          this.input.setAttribute('aria-expanded', 'true')
        }

        if (this.emptyContainer) this.emptyContainer.setAttribute('hidden', 'hidden')
        if (this.cartUpsells) this.cartUpsells.setAttribute('hidden', 'hidden')
        if (this.status && this.querySelector('#predictive-search-results')) {
          this.status.textContent = this.querySelector('#predictive-search-results').dataset.resultsText || ''
        }
      }
    } catch (err) {
      console.error('Predictive search error:', err)
    } finally {
      this.removeAttribute('loading')
    }
  }

  closeResults () {
    if (this.results) {
      this.results.style.display = 'none'
    }
    this.input.setAttribute('aria-expanded', 'false')
    if (this.emptyContainer) this.emptyContainer.removeAttribute('hidden')
    if (this.cartUpsells) this.cartUpsells.removeAttribute('hidden')
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}